import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { CircularProgress } from "@mui/material";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import {
    SaveRounded,
} from "@mui/icons-material";
import DataTable from "../common/DataTable";
import CustomModal from "../common/CustomModal";
import { CREATE_PARTY_LEDGER, DELETE_PARTY_LEDGER, GET_PARTY_LEDGER_LIST, } from "../../services/apiRoutes"
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../common/CustomLoader";
import MessageBox from "../common/CustomMessageBox";
import { AuthContext } from "../../context/AuthContext";
import CreateManageProducts from "./CreateMasters/CreateManageProducts";
import { genericGet } from "../../services/apiServices";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";
import CustomMaster from "../common/CustomMaster";
import CustomAutocomplete from "../common/CustomAutoComplete";
import { getColorPlate, getCountries } from "../../services/CommonServices";
import CustomStatus from "../common/CustomStatus";
import CustomDelete from '../common/CustomDeleteAlert';
import axios from "axios";
import UpdatePortMasters from "./UpdateMaster/UpdatePortMasters";
import UpdatePartyLedger from "./UpdateMaster/UpdatePartyLedger";


const title = "Party Ledger";

const ValidationSchema = Yup.object().shape({
    partyName: Yup.string()
        .required("Party Name is required"),
    ledgerShortName: Yup.string()
        .required("Sort Name is required"),
    colorId: Yup.string()
        .required("Color is required"),

});

const PartyLedger = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [colorList, setColorList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [conutries, setConutries] = useState([]);


    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "partyName", header: "party Name",
                tableHeader: {
                    justifyContent: 'flex-start',
                },
                size: 100,
                Cell: ({ row }) => (
                    <>
                        <CustomStatus
                            title={row.original.partyName}
                            sx={{
                                backgroundColor: row.original.backgroundColor,
                                color: row.original.color,
                                textAlign: "center",
                                display: "inline-block",
                                border: `1px solid ${row.original.color}`,
                            }}
                        />
                    </>
                ),
                enableSorting: false
            },

            {
                accessorKey: "ledgerShortName", header: "Short Name", tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 50
            },

            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <IconButton onClick={() => handleUpdateClick(row.original.partyLedgerId)}>
                                <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                            </IconButton>
                            <IconButton
                                onClick={() => handleOpenDeleteAlert(row.original.partyLedgerId)}
                            >
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>
                        </div>
                    </>

                ),
            },

        ],
        []
    );
    const handleUpdateClick = (partyLedgerId) => {
        setSelectedId(partyLedgerId);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };


    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await genericGet({ url: GET_PARTY_LEDGER_LIST });

            if (response?.data?.partyLedgerList) {
                const customData = response.data.partyLedgerList.map((item, index) => ({
                    ...item,
                    index: (index + 1).toString().padStart(2, '0'),
                    partyLedgerId: item.partyLedgerId,
                    partyName: item?.partyName || "",
                    ledgerShortName: item?.ledgerShortName || "",
                    backgroundColor: item.ColorPlate?.backgroundColor || '',
                    color: item.ColorPlate?.color || '',

                }));

                setData(customData);
            }
        } catch (error) {
            console.error("Error fetching port masters", error);
            setError("Failed to load port masters");
        } finally {
            setLoading(false);
        }
    };

    const fetchColorPlate = async () => {
        const colorData = await getColorPlate();
        setColorList(colorData);
    };
    const getCommonData = async () => {
        const getConutriesData = await getCountries()
        setConutries(getConutriesData)
    }

    useEffect(() => {
        fetchData()
        fetchColorPlate()
        getCommonData()
    }, [token])

    const handleOpen = () => {
        setModal(true);
    };
    const handleClose = () => {
        setModal(false)
    }

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                partyName: values.partyName,
                ledgerShortName: values.ledgerShortName,
                colorId: values.colorId,
            };
            const response = await genericPost(CREATE_PARTY_LEDGER, payload);
            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData();
                }, 1000);
                resetForm();
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };
    const handleDelete = async (partyLedgerId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_PARTY_LEDGER(partyLedgerId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                setDeleteAlert(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const [formData] = useState({
        partyName: '',
        ledgerShortName: '',
        colorId: '',
    });
    const defaultView = 'partyLedger';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <Box   >
                    <Formik
                        initialValues={formData}
                        validationSchema={ValidationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, errors, touched, setFieldValue, values, handleChange }) => (
                            <Form>
                                <Grid container spacing={2} sx={{ px: "0%" }}>
                                    <Grid item xs={12} md={3}>
                                        <CustomTextField
                                            placeholder="Enter Party Name"
                                            name="partyName"
                                            fieldLabel="Party Name"
                                            required
                                            value={values.partyName}
                                            onChange={handleChange}
                                            error={touched.partyName && !!errors.partyName}
                                            helperText={touched.partyName && errors.partyName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <CustomTextField
                                            placeholder="Enter Short Name"
                                            name="ledgerShortName"
                                            fieldLabel="Short Name"
                                            required
                                            value={values.ledgerShortName}
                                            onChange={handleChange}
                                            error={touched.ledgerShortName && !!errors.ledgerShortName}
                                            helperText={touched.ledgerShortName && errors.ledgerShortName}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <CustomAutocomplete
                                            options={colorList}
                                            fieldLabel="Select Color"
                                            required
                                            getOptionLabel={(option) => `${option.colorName}`}
                                            renderOption={(props, option) => (
                                                <li {...props}
                                                    style={{
                                                        backgroundColor: option.backgroundColor,
                                                        color: option.color,
                                                        border: `1px solid ${option.color}`,
                                                        display: 'inline-flex',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                        borderRadius: '4px',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        textTransform: "capitalize",
                                                        height: "25px",
                                                        padding: "2px 6px 2px 6px",
                                                        zIndex: -1,
                                                        marginLeft: "40px",
                                                        marginRight: "40px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px"

                                                    }}>
                                                    {`${option.colorName}`}
                                                </li>
                                            )}
                                            value={colorList.find(color => color.colorId === values.colorId) || null}
                                            onChange={(_, newValue) => {
                                                setFieldValue("colorId", newValue ? newValue.colorId : "");
                                            }}
                                            placeholder="Select color"
                                            error={touched.colorId && !!errors.colorId}
                                            helperText={touched.colorId && errors.colorId}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <Box style={{ paddingTop: "22px" }}>
                                            <CustomButton
                                                startIcon={<SaveRounded />}
                                                title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                                size="small"
                                                variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </Box>
                <CustomLoader open={loading} />
                <DataTable
                    title={title}
                    columns={columns}
                    data={data}
                    handleOpen={handleOpen}
                />
                <CustomModal
                    modalStyles={{
                        maxHeight: '55vh',
                        top: "10%",
                    }}
                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdatePartyLedger
                        handleClose={handleCloseUpdate}
                        partyLedgerId={selectedId}
                        fetchData={fetchData}
                        colorList={colorList}
                        setMessage={setMessage}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
            </Box>
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );
    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default PartyLedger;



